import script from "./CustomerStatusListPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerStatusListPanel.vue?vue&type=script&setup=true&lang=js"

import "./CustomerStatusListPanel.vue?vue&type=style&index=0&id=2d95b79e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d95b79e"]])

export default __exports__